module.exports = __webpack_public_path__ + "img/iconVip.f2f46390.svg";